"use client"

import type { FC, ReactNode } from "react"
import { YandexMetricaProvider } from "@/lib/next-yandex-metrika"
import { Env } from "@/env.mjs"

interface Props {
    children: ReactNode
}

export const YandexMetrika: FC<Props> = ({ children }) => {
    return (
        <YandexMetricaProvider
            tagID={Env.NEXT_PUBLIC_YANDEX_METRIKA_ID}
            router="app"
            initParameters={{
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
            }}
        >
            {children}
        </YandexMetricaProvider>
    )
}
